import { EntityType } from '@shared/models/entity-enum';

export const CLIPBOARD_SEARCH_STATE_KEY = 'CLIPBOARD_SEARCH_STATE';

export type ClipboardSearchConfigs = {
  [key in EntityType]?: ClipboardSearchConfigByEntity;
};

export interface ClipboardSearchConfigByEntity {
  simplifyDataByUsageType?: string[];
  isSpacesViewActive?: boolean;
}

export enum RefreashSearchEvtActions {
  Update = 'Update',
  ClearAll = 'ClearAll',
}

export interface RefreashSearchEvt {
  action: RefreashSearchEvtActions;
  entity: EntityType;
  refresh: boolean;
  data: ClipboardSearchConfigs | ClipboardSearchConfigByEntity;
}
